"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeStyles = exports.mergeStyles = exports.useStyles = void 0;
const tslib_1 = require("tslib");
const jss_1 = require("jss");
const jss_plugin_camel_case_1 = tslib_1.__importDefault(require("jss-plugin-camel-case"));
const jss_plugin_default_unit_1 = tslib_1.__importDefault(require("jss-plugin-default-unit"));
const jss_plugin_nested_1 = tslib_1.__importDefault(require("jss-plugin-nested"));
const react_1 = require("react");
const utils_1 = require("./utils");
const store_1 = require("../../store");
const jss = (0, jss_1.create)({ plugins: [(0, jss_plugin_camel_case_1.default)(), (0, jss_plugin_nested_1.default)(), (0, jss_plugin_default_unit_1.default)()] });
const useStyles = ({ target, source }, componentNamespace) => {
    const styles = (0, utils_1.mergeStylesObjects)(target !== null && target !== void 0 ? target : {}, source !== null && source !== void 0 ? source : {});
    const sheet = jss.createStyleSheet(styles, { classNamePrefix: `${store_1.videoStylesNamespace}-${componentNamespace}-` });
    (0, react_1.useLayoutEffect)(() => {
        sheet.attach();
        return () => {
            sheet.detach();
        };
    }, [sheet]);
    // return sheet.classes;
    // Is this overkill now?
    return Object.keys(sheet.classes).reduce((accumulator, curr) => ({
        ...accumulator,
        [curr]: `${sheet.classes[curr]}`,
    }), {});
};
exports.useStyles = useStyles;
/**
 * @deprecated use useStyles() instead
 */
exports.mergeStyles = exports.useStyles;
/**
 * @deprecated use useStyles() instead
 */
const makeStyles = (styles, namespace) => (0, exports.useStyles)({ target: styles, source: {} }, namespace.classNamePrefix);
exports.makeStyles = makeStyles;
//# sourceMappingURL=videoStyles.js.map